import * as React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import * as styles from '../styles.module.less';
import productListIcon1 from '../../images/product-list-1.svg';
import productListIcon2 from '../../images/product-list-2.svg';
import productListIcon3 from '../../images/product-list-3.svg';
import NottaLogo from '../../images/Logo-Notta-Dark.png';
import { Dropdown } from 'antd';
import { useMemoizedFn } from 'ahooks';
import { PublicMenu } from 'notta-web-icon';
import { getABTestLoginSignUpUrl } from '@/utils';
import { WEB_APP_JP_LOGIN_IN_URL, WEB_APP_JP_SIGN_UP_URL } from '@/constants';

const { useState, useEffect } = React;

interface WrapperLinkProps {
  children: React.ReactNode;
  to: string;
  id?: string;
  className?: string;
  tabIndex?: number;
  style?: any;
  target?: string;
}

/*
  小工具页面开启了跨域隔离，跳转组件使用Link会导致跳转的目标页面图片资源拉不下来，
  因为使用Link跳转会以小工具页面为单页面复应用入口，以至于资源请求均处于跨域隔离状态。
  而使用 a 标签相当于打开另一个html页面可以避免这个问题。
*/
export const Wrapper = (isMediaTool) => {
  if (isMediaTool) {
    return ({ children, to, id, className, tabIndex, style, target = '_self' }: WrapperLinkProps) => (
      <a href={to} id={id} className={className} style={style} tabIndex={tabIndex} target={target}>
        {children}
      </a>
    );
  } else {
    return Link;
  }
};
interface IProps {
  isMediaTool?: boolean;
  isNewLayout?: boolean;
}

/**
 * TODO: 旧的日文导航栏
 * @param param0
 * @returns
 */

const Header: React.FC<IProps> = ({ isMediaTool, isNewLayout }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [navMenuOpen, setNavMenuOpen] = useState(false);
  const [openTeamsDropdown, setOpenTeamsDropdown] = useState(false);
  const [loginUrl, setLoginUrl] = useState(WEB_APP_JP_LOGIN_IN_URL);
  const [signUpUrl, setSignUpUrl] = useState(WEB_APP_JP_SIGN_UP_URL);

  const handleOpenTeamsDropdown = () => {
    setOpenTeamsDropdown(!openTeamsDropdown);
  };

  const LinkWrapper = Wrapper(isMediaTool);

  const ProductionItems = [
    {
      key: '1',
      label: (
        <LinkWrapper
          to="/web"
          id="product_webapp_tab"
          className={`dropdown-link-new navigation-bar-new dropdown-item w-dropdown-link ${styles.new_dropdown_item}`}
        >
          <img src={productListIcon1} alt="Web版" />
          <div className={styles.dropdown_item_right}>
            <span className={styles.dropdown_item_right_title}>Web版</span>
            <span className={styles.dropdown_item_right_desc}>PCでインストール不要の文字起こしツール</span>
          </div>
        </LinkWrapper>
      ),
    },
    {
      key: '2',
      label: (
        <LinkWrapper
          to="/mobile"
          className={`dropdown-link-new navigation-bar-new dropdown-item w-dropdown-link ${styles.new_dropdown_item}`}
        >
          <img src={productListIcon2} alt="アプリ" />
          <div className={styles.dropdown_item_right}>
            <span className={styles.dropdown_item_right_title}>アプリ</span>
            <span className={styles.dropdown_item_right_desc}>iOS/Androidで使える文字起こしアプリ</span>
          </div>
        </LinkWrapper>
      ),
    },
    {
      key: '3',
      label: (
        <LinkWrapper
          to="/chrome-extension"
          id="product_extension_tab"
          className={`dropdown-link-new navigation-bar-new dropdown-item w-dropdown-link ${styles.new_dropdown_item}`}
        >
          <img src={productListIcon3} alt="Chrome拡張機能" />
          <div className={styles.dropdown_item_right}>
            <span className={styles.dropdown_item_right_title}>Chrome拡張機能</span>
            <span className={styles.dropdown_item_right_desc}>
              同時に複数のChromeタブに再生している音声を文字起こし
            </span>
          </div>
        </LinkWrapper>
      ),
    },
  ];

  const TeamsItems = [
    {
      key: '1',
      label: (
        <LinkWrapper to="/features" className="dropdown-link-new navigation-bar-new dropdown-item w-dropdown-link">
          機能紹介
        </LinkWrapper>
      ),
    },
    {
      key: '2',
      label: (
        <LinkWrapper to="/import-guide" className="dropdown-link-new w-dropdown-link">
          導入の流れ
        </LinkWrapper>
      ),
    },
  ];

  const MobileTeamsItems = [
    {
      key: '1',
      label: (
        <LinkWrapper
          to="/features"
          id="product_webapp_tab"
          className="dropdown-link-new navigation-bar-new dropdown-item w-dropdown-link"
          tabIndex={0}
        >
          機能紹介
        </LinkWrapper>
      ),
    },
    {
      key: '2',
      label: (
        <LinkWrapper to="/import-guide" id="product_app_tab" className="dropdown-link-new w-dropdown-link" tabIndex={0}>
          導入の流れ
        </LinkWrapper>
      ),
    },
  ];
  const MobileProductionItems = [
    {
      key: '1',
      label: (
        <LinkWrapper to="/web" id="product_webapp_tab" className={styles.mobile_dropdown_link}>
          Web版
        </LinkWrapper>
      ),
    },
    {
      key: '2',
      label: (
        <LinkWrapper to="/mobile" id="product_app_tab" className={styles.mobile_dropdown_link}>
          アプリ
        </LinkWrapper>
      ),
    },
    {
      key: '3',
      label: (
        <LinkWrapper to="/chrome-extension" id="product_extension_tab" className={styles.mobile_dropdown_link}>
          Chrome拡張機能
        </LinkWrapper>
      ),
    },
  ];

  const handleChangeDropDown = () => {
    setOpenDropdown(!openDropdown);
  };

  const handleSwitch = useMemoizedFn((e) => {
    if (e.target.outerText === 'プロダクト' || e.target.outerText === 'ビジネス版について') return;
    if (navMenuOpen) setNavMenuOpen(false);
  });

  useEffect(() => {
    setSignUpUrl(getABTestLoginSignUpUrl('signup'));
    setLoginUrl(getABTestLoginSignUpUrl('login'));
  }, [typeof window !== 'undefined' && window.location.pathname]);

  useEffect(() => {
    document.addEventListener('click', handleSwitch);

    return () => {
      window.removeEventListener('click', handleSwitch);
    };
  }, [handleSwitch]);

  return (
    <div
      id="navigation-bar"
      data-animation="default"
      data-collapse="medium"
      data-duration={200}
      data-easing="ease-out-cubic"
      data-easing2="ease-out-cubic"
      role="banner"
      className="navigation-bar-new w-nav"
    >
      <div
        className={classnames(
          styles.nav_bar,
          'navigation-bar layout-container',
          isNewLayout && styles.new_home_page_nav,
        )}
      >
        <LinkWrapper to="/" aria-current="page" className={`${styles.brand_logo}`}>
          <img src={NottaLogo} alt="Notta logo" className={styles.notta_logo} style={{ height: 32 }} />
        </LinkWrapper>
        <nav role="navigation" className={`nav-menu-new w-nav-menu ${styles.w_nav_menu}`}>
          <div className="div-new link-block-new navigation-bar-new">
            <Dropdown
              menu={{ items: ProductionItems }}
              overlayStyle={{ width: '370px', borderRadius: '12px' }}
              onOpenChange={handleChangeDropDown}
              trigger={['click', 'hover']}
            >
              <div className="dropdown-toggle-new navigation-bar-new w-dropdown-toggle">
                <div>プロダクト</div>
                <div
                  className={classnames(
                    'dropdown-arrow-new navigation-bar w-icon-dropdown-toggle',
                    styles.dropdown_arrow,
                    { [styles.is_active]: openDropdown },
                  )}
                />
              </div>
            </Dropdown>

            <LinkWrapper to="/guides" id="guides_tab_menu" className="text-link-new navigation-bar-new w-nav-link">
              ご利用ガイド
            </LinkWrapper>
            <a href="/blog" target="_self" className="text-link-new navigation-bar-new">
              ブログ
            </a>
            <LinkWrapper to="/pricing" id="pricing_tab_menu" className="text-link-new navigation-bar-new w-nav-link">
              料金プラン
            </LinkWrapper>
            <LinkWrapper to="/about" className="text-link-new navigation-bar-new">
              資料請求
            </LinkWrapper>

            <Dropdown
              menu={{ items: TeamsItems }}
              overlayStyle={{ borderRadius: '12px' }}
              onOpenChange={handleOpenTeamsDropdown}
              trigger={['click', 'hover']}
            >
              <div className="dropdown-toggle-new navigation-bar-new w-dropdown-toggle">
                <div>ビジネス版について</div>
                <div
                  className={classnames(
                    'dropdown-arrow-new navigation-bar w-icon-dropdown-toggle',
                    styles.dropdown_arrow,
                    { [styles.is_active]: openTeamsDropdown },
                  )}
                />
              </div>
            </Dropdown>
            <LinkWrapper to="/cases" id="to_cases" className="text-link-new navigation-bar-new">
              導入事例
            </LinkWrapper>
          </div>
        </nav>
        <div className={styles.header_right}>
          <div className="div-new block-new navigation-bar-new">
            <a href={loginUrl} id="login_btn" className="button-new secondary navigation-bar-new w-nav-link">
              ログイン
            </a>
            <a
              href={signUpUrl}
              id="signup_btn"
              target="_blank"
              className="button-new primary navigation-bar-new-new w-nav-link"
              rel="noreferrer"
            >
              新規登録
            </a>
          </div>
          <div
            className={classnames(styles.menu_btn, {
              'w--open': navMenuOpen,
            })}
            onClick={(e) => {
              e.stopPropagation();
              setNavMenuOpen(!navMenuOpen);
            }}
          >
            <PublicMenu size={16} />
          </div>
        </div>
      </div>
      <div
        className={`w-nav-overlay ${styles.w_nav_overlay}`}
        data-wf-ignore=""
        id="w-nav-overlay-0"
        style={{ display: navMenuOpen ? 'block' : 'none', height: '100vh ' }}
      >
        <nav
          role="navigation"
          className={`nav-menu-new w-nav-menu ${styles.line_new_nav}`}
          style={{
            transform: 'translateY(0px) translateX(0px)',
            transition: 'transform 200ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s',
          }}
          data-nav-menu-open=""
        >
          <div className={`div-new link-block-new navigation-bar-new ${styles.line_new}`}>
            <Dropdown
              menu={{ items: MobileProductionItems }}
              trigger={['click', 'hover']}
              onOpenChange={handleOpenTeamsDropdown}
            >
              <div
                className="dropdown-toggle-new navigation-bar-new w-dropdown-toggle w--nav-dropdown-toggle-open"
                id="w-dropdown-toggle-0"
                aria-controls="w-dropdown-list-0"
                aria-haspopup="menu"
                aria-expanded="false"
                role="button"
              >
                <div>プロダクト</div>
                <div
                  className={classnames(
                    'dropdown-arrow-new navigation-bar w-icon-dropdown-toggle',
                    styles.dropdown_arrow,
                    { [styles.is_active]: openTeamsDropdown },
                  )}
                  aria-hidden="true"
                ></div>
              </div>
            </Dropdown>

            <LinkWrapper
              to="/guides"
              id="guides_tab"
              className="text-link-new navigation-bar-new w-nav-link w--nav-link-open"
              style={{ maxWidth: '100%' }}
            >
              ご利用ガイド
            </LinkWrapper>

            <a href="/blog" target="_self" id="blog_tab" className="text-link-new navigation-bar-new">
              ブログ
            </a>
            <LinkWrapper
              to="/pricing"
              id="pricing_tab"
              className="text-link-new navigation-bar-new w-nav-link w--nav-link-open"
              style={{ maxWidth: '100%' }}
            >
              料金プラン
            </LinkWrapper>
            <LinkWrapper to="/about" id="contact_tab" className="text-link-new navigation-bar-new">
              資料請求
            </LinkWrapper>

            <Dropdown
              menu={{ items: MobileTeamsItems }}
              trigger={['click', 'hover']}
              onOpenChange={handleChangeDropDown}
            >
              <div
                className="dropdown-toggle-new navigation-bar-new w-dropdown-toggle w--nav-dropdown-toggle-open"
                id="w-dropdown-toggle-0"
                aria-controls="w-dropdown-list-0"
                aria-haspopup="menu"
                aria-expanded="false"
                role="button"
                tabIndex={0}
              >
                <div>ビジネス版について</div>
                <div
                  className={classnames(
                    'dropdown-arrow-new navigation-bar w-icon-dropdown-toggle',
                    styles.dropdown_arrow,
                    { [styles.is_active]: openDropdown },
                  )}
                  aria-hidden="true"
                ></div>
              </div>
            </Dropdown>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
